export default {
  dataIterator: {
    rowsPerPageText: 'Objets par page:',
    rowsPerPageAll: 'Toute',
    pageText: '{0}-{1} sur {2}',
    noResultsText: 'Aucun enregistrements correspondants trouvés',
    nextPage: 'Page suivante',
    prevPage: 'Page précédente'
  },
  dataTable: {
    rowsPerPageText: 'Lignes par page:'
  },
  noDataText: 'Pas de données disponibles',
  carousel: {
    prev: 'Visuel précédent',
    next: 'Visuel suivant'
  },
  errors: {
    codeIncorrect: 'Le code est incorrect',
    errorLogin: 'Erreur de connexion',
    qr: {
      notAllowed: "ERREUR: vous devez accorder l'autorisation d'accès à la caméra",
      notFound: 'ERREUR: impossible de trouver la caméra sur cet appareil',
      notSupported: 'ERREUR: contexte sécurisé requis (HTTPS, localhost)',
      notReadable: 'ERREUR: la caméra est-elle déjà utilisée?',
      overConstrained: 'ERREUR: les caméras installées ne conviennent pas',
      streamAPINotSupported: "ERREUR: l'API Stream n'est pas prise en charge dans ce navigateur",
      scanFailed: 'Code QR non valide',
      tableNumberFailed: 'Numéro de table non valide'
    },
    location: {
      inStoreTitle: "Votre position actuelle n'est pas en magasin",
      inStoreDescription: 'Vous ne pouvez pas passer une commande de restauration sur place, veuillez sélectionner Ramassage ou Livraison',
      inStoreBtn: "J'accepte",
      locationDisabledTitle: 'Veuillez autoriser la localisation GPS',
      locationDescription: "Veuillez scanner à nouveau le code QR et autoriser la localisation GPS ou l'activer directement à partir des paramètres de votre téléphone",
      locationBtn: "J'accepte"
    },
    cart: {
      menuUnavailable: "Le menu n'est pas disponible pendant ces heures",
      startShopping: 'Commencer la commande'
    },
    schedule: {
      availableTimes: "{0} n'est disponible que de {1} à {2}",
      unavailableTimes: "{0} n'est pas disponible de {1} à {2}",
      availableDay: '{0} sera disponible {1}',
      unavailable: "{0} n'est pas disponible actuellement. Essayez un autre type de commande",
      startScheduling: 'Vous pouvez commencer à planifier des commandes à {0}'
    },
    paymentUnsuccessful: 'Échec de paiement',
    temporarilyAppear: "Ces frais peuvent apparaître temporairement sur votre relevé avant d'être supprimés",
    pageNotFound: 'Page Non Trouvée',
    storeNotFoundMessage: 'Le magasin que vous recherchez est introuvable. Il a peut-être été déplacé, supprimé, ou l\'URL est incorrecte.'
  },
  common: {
    storeHoursClosedHoliday: "Fermé",
    today: 'Aujourd\'hui',
    nextAvailable: 'Prochainement disponible',
    referralButtonText: 'Invitez vos amis',
    pointsEarned: 'Points gagnés',
    confirmTitle: 'Veuillez confirmer',
    confirmDesc: 'Êtes-vous sûr de vouloir changer le mode de commande Dine-in?',
    actionText: 'Oui, changer',
    hours: 'Heures d\'ouverture',
    location: 'Emplacements',
    contact: 'Informations de contact',
    socials: "Réseaux sociaux",
    snappyWhy: 'Pourquoi Snappy',
    snappyBlog: 'Blog',
    snappyPricing: 'Tarifs',
    snappyDemo: 'Réserver une démo',
    snappyCaseStudies: 'Études de cas',
    orderNow: 'Commander maintenant',
    clickToRedeem: 'Cliquez pour racheter',
    pickup: 'Ramassage',
    delivery: 'Livraison',
    availableToDeliver: 'Disponible pour la livraison',
    notAvailableForDelivery: 'Non disponible pour la livraison',
    loginDescription: 'Inscrivez-vous ou connectez-vous maintenant pour débloquer des coupons exclusifs, des récompenses et des offres personnalisées rien que pour vous !',
    apply: 'Appliquer',
    order: 'Commander',
    sortByDistance: 'Trier par distance',
    sortByAlpha: 'Trier par ordre alphabétique',
    searchLocations: 'Rechercher des emplacements',
    az: 'A-Z',
    nearest: 'Le plus proche',
    atLeast: 'Au moins',
    to: 'à',
    takeout: 'Ramasser',
    or: 'ou',
    guest: 'Client',
    back: 'Retour',
    other: 'Autre',
    groups: 'Groupes',
    options: 'Options',
    edit: 'Éditer',
    register:'S\'inscrire',
    poweredBy: 'Créé par',
    firstName: 'Prénom',
    lastName: 'Nom de famille',
    phone: 'Téléphone',
    phoneNumber: 'Numéro de téléphone',
    address: 'Adresse',
    storeHours: 'Heures du magasin',
    onlineOrderAvailableUntil: "Commande en ligne disponible jusqu'à",
    mobileNumber: 'Numéro de portable',
    status: 'Statut',
    points: 'Points',
    balance: 'Solde du compte',
    save: 'sauvegarder',
    changesSaved: 'Changements sauvegardés',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    message: 'Message',
    loadMore: 'Charger plus',
    loading: 'Chargement...',
    expires: 'Expire',
    login: "S'identifier / S'inscrire",
    tweet: 'Tweeter',
    share: 'Partager',
    continue: 'Continuer',
    resend: '(Renvoyer dans: {0})',
    newCode: 'Nouveau code',
    logout: 'Se déconnecter',
    fillFields: 'Merci de remplir tous les champs',
    invalidEmail: 'E-mail is invalid',
    verify: 'Vérifier',
    verifyCode: 'Vérifier le code',
    sixDigitCode: 'Code à 6 chiffres',
    unlimited: 'Illimité',
    upTo: "Jusqu'à",
    selected: 'sélectionné',
    items: 'articles',
    amount: 'Somme',
    scanQRCode: 'Scannez le code QR manger sur place',
    loadingQRScanner: 'Chargement du scanner ...',
    reloadQRScanner: 'Recharger',
    open: 'Ouvert',
    open2: 'Ouvert',
    closed: 'Fermé',
    closed2: 'Fermé',
    email: 'Email',
    select: 'Sélectionner',
    ok: "D'accord",
    okConfirm: "D'accord",
    off: 'de réduction',
    app: {
      text1: 'Ouvrir dans',
      text2: 'App ',
      btn: 'Ouvert'
    },
    captcha: {
      main: 'Ce site est protégé par reCAPTCHA et Google',
      privacy: 'Politique de confidentialité',
      and: 'et',
      terms: "Conditions d'utilisation",
      apply: 'Appliquer.'
    },
    disclaimer: {
      main: 'En vous connectant, j\'accepte les <link-tos>Conditions d\'utilisation</link-tos> et la <link-pp>Politique de confidentialité</link-pp>. Je consens à recevoir des messages SMS et d\'autres communications numériques, y compris des coupons, des offres spéciales et des promotions de {businessName}. Des frais standards de messages et de données peuvent s\'appliquer.',
      register: 'En cliquant sur S\'inscrire, vous acceptez les <link-tos>conditions d\'utilisation</link-tos> et la <link-pp>politique de confidentialité</link-pp> de Snappy. Snappy utilisera les informations SMS pour sécuriser votre compte et envoyer des notifications. Vous pouvez vous désabonner des SMS à tout moment.'
    },
    addedToCart: 'ajouté {0} au panier',
    yourOrderId: 'Your Order ID is'
  },
  hours: {
    twentyFourHours: 'Ouvert 24 heures',
    midNight: 'Minuit',
    mon: "Lun",
    tues: "Mar",
    wed: "Mer",
    thurs: "Jeu",
    fri: "Ven",
    sat: "Sam",
    sun: "Dim",
    monday: "Lun",
    tuesday: "Mar",
    wednesday: "Mer",
    thursday: "Jeu",
    friday: "Ven",
    saturday: "Sam",
    sunday: "Dim"
  },
  menu: {
    specialRequests: 'Instructions spéciales',
    required: 'Obligatoire',
    optional: 'Optionnel',
    soldOut: 'Épuisé',
    selectMenu: 'Veuillez sélectionner un menu',
    menuTitle: 'Menu',
    promotionsAndRewards: 'Promotions et récompenses',
    categories: 'Catégories',
    noMenu:  'Aucun menu trouvé en magasin',
    dropdown: 'Menu Déroulant',
    unavailable: 'Menu unavailable',
    available: 'Heures disponibles',
    dayAvailable: 'Suivant disponible',
    availableOffHours: 'Ce menu est disponible pour les commandes planifiées',
    menuIsExclusive: 'Les articles de différents menus ne peuvent pas être ajoutés au même panier',
    item: {
      onlyAvailable: 'Disponible',
      available: 'This item is only available from {0} - {1}',
      prepTime: 'L\'article prend généralement environ {0} pour être préparé.'
    },
    menuAvailability: 'Disponible pour planification',
    gotIt: "Compris!",
    onlyAvailable: 'Ce menu est uniquement disponible à des heures spécifiques :',
    pricingBanner: 'Commandez directement auprès de {2} et économisez jusqu\'à {0}% en moyenne par rapport à {1}'
  },
  cart: {
    title: 'Panier',
    startShopping: 'Commencer les achats',
    continue: 'Continuer',
    serviceFee: 'Frais de service',
    takeOutOrder: 'Commande à Emporter',
    backToLogin: 'Retour connexion',
    enterYourAddress: 'Entrez votre adresse',
    startAdding: 'Commencez à ajouter des articles à partir du menu pour créer votre commande.',
    buildOrder: "Ajoutez de nouveaux articles pour continuer à construire votre commande",
    currentlyClosed: ' est actuellement fermé. Veuillez revenir aux heures appropriées.',
    delivery: 'Livraison',
    pickup: 'Ramassage',
    dinein: 'Dîner sur place',
    estTimeHours: 'heures',
    estTimeMins: 'mins',
    subtotal: 'Total',
    deliveryFee: 'Frais de livraison',
    tbd: 'À déterminer',
    deliveryMinimum: 'Minimum pour la livraison',
    pickupMinimum: 'Minimum pour ramassage',
    tax: 'Taxe',
    tip: 'Pourboire',
    tipDriver: 'Pourboire le conducteur',
    tipStore: 'Soutenez le magasin en donnant des pourboires',
    rewards: 'Récompenses',
    total: 'Total',
    btnCheckout: 'Procéder au paiement',
    addToCart: 'Ajouter au panier',
    aiRecommendationsTitle: 'Recommandé pour vous',
    aiRecommendationsTitleGuest: 'Recommandé',
    aiRecommendationsSubtitle: "D'après vos commandes",
    aiRecommendationsSubtitleGuest: 'Populaires dans ce magasin',
    aiRecommendationsFrom: 'À partir de',
    saveCartItem: 'Mise à jour panier',
    clickToSee: 'Cliquez pour voir les options',
    payWithMembership: "Payer avec l'adhésion",
    btnSubmitSubOrder: 'Soumettre la commande',
    processing: 'Traitement de votre commande',
    pastOrders: 'Commandes passées',
    discount: 'Réduction',
    btnPayOrder: 'Payer la commande',
    closeModal: 'Fermer',
    cartUnavailable: "Il y a des articles dans votre panier qui ne peuvent pas être commandés en raison d'une disponibilité contradictoire ou invalide",
    storeUnavailable: 'actuellement indisponible',
    storeClosedBtn: 'Magasin fermé',
    offHourOrderingMaybeAllowed: 'Le magasin est actuellement fermé. Cependant, vous pouvez toujours planifier une commande pour plus tard.',
    advanceBookingWindow: 'Le magasin est ouvert mais n\'accepte pas encore les commandes. Vous pouvez planifier une commande pour plus tard.',
    deliveryUnavailable: 'La livraison est actuellement indisponible',
    pickupUnavailable: 'Le ramassage est actuellement indisponible',
    tooSmallForDelivery: 'Montant de la commande trop petit pour la livraison (Min: {0})',
    tooSmallForPickup: 'Montant de la commande trop petit pour le ramassage (Min: {0})',
    invalidCoupon: 'Coupon invalide',
    cartErrors: 'Erreurs de panier',
    removeInvalidItemToContinue: 'Veuillez le retirer pour continuer.',
    discountNotUsed: 'Le panier ne doit pas être vide',
    deliveryDisabled: 'La livraison est temporairement désactivée par le marchand',
    pickupDisabled: 'Le ramassage est temporairement désactivé par le marchand',
    deliveryDisabledUntil: 'La livraison est temporairement désactivée par<br>le marchand jusqu\'à {0}',
    pickupDisabledUntil: 'Le ramassage est temporairement désactivé par<br>le marchand jusqu\'à {0}',
    asapClosed: 'Fermé · Ouvre {0} à {1}',
    asapPastCutoff: "N'accepte plus de commandes pour aujourd'hui",
    asapSuspendedToday: "N'accepte plus de commandes pour aujourd'hui",
    storeStoppedAcceptingOrders: "Le restaurant a cessé d'accepter des commandes pendant que vous finalisiez votre commande. Choisissez une heure programmée pour continuer."
  },
  account: {
    accountInfo: 'Informations de compte',
    orderHistory: 'Historique des commandes',
    paymentMethods: 'Méthodes de payement',
    contactInfo: 'Informations de contact',
    membershipInfo: 'Informations sur mon adhésion',
    member: 'Membre',
    nonMember: 'Pas un membre',
    creditCard: 'Carte de crédit',
    nameOnCard: 'Nom sur la carte',
    cardNumber: 'Numéro de carte',
    expires: "Date d'expiration",
    cvc: 'CVC',
    mmyy: 'MM / AA',
    country: 'Pays de facturation',
    saveCard: 'Enregistrer la carte',
    addPaymentMethod: 'Ajouter un mode de paiement',
    deliveryDetails: 'Détails de livraison',
    noOrderHistory: "Pas d'historique de commande)",
    noPaymentMethods: 'Aucun mode de paiement',
    addPaymentMethodPrompt: 'Veuillez ajouter un mode de paiement',
    noCreditCards: 'Aucun mode de paiement',
    otherPostalCode: 'Pour les cartes non américaines ou canadiennes, veuillez entrer un nombre quelconque',
    membership: 'Adhésion',
    history: 'Histoire',
    payments: 'Paiements',
    offline: 'Payer en personne',
    orderId: 'Numéro de commande',
    editTitle: 'Modifier les informations personnelles',
    payment: {
      title: 'Supprimer le mode de paiement',
      body: 'Voulez-vous vraiment supprimer ce mode de paiement?',
      cancel: 'Annuler',
      delete: 'Effacer',
      status: {
        cvcFailed: 'CVC invalide',
        postalCodeFailed: 'Code postal invalide',
        expiredCard: 'Carte expirée'
      }
    },
    rewards: {
      redeemFor: 'Racheter pour',
      rewardOptions: 'Options de récompense',
      coupons: 'Coupons',
      punchCards: 'Cartes perforées',
      using: 'Utilisant',
      remaining: 'Restant',
      free: 'Gratuit',
      purchases: 'Achats',
      redeem: 'Racheter',
      max: 'Max',
      points: 'Points',
      credits: 'Credits',
      discount: 'Réduction',
      yourPoints: 'Vos points',
      creditsEarned: '{0} earned',
      worth: 'Vaut',
      insufficientFunds: 'Pas assez de points',
      removeFirst: 'Veuillez supprimer votre option de récompense active',
      punchCardRibbon: 'Achetez {0} plus {1} pour {2}!',
      selectItem: "Sélectionnez l'élément",
      availableInCart: 'Les récompenses disponibles sont affichées dans le panier ',
      availableInCartUpdated: 'Utilisez cette offre dans votre panier!',
      alreadyInCart: '{0} est déjà dans votre panier',
      missingPoints: 'Vous avez besoin de {0} points supplémentaires pour utiliser cette carte perforée!',
      inEligible: "Vous n'êtes pas éligible pour ce coupon",
      noExpiration: "Sans expiration",
      noLimitation: "Sans limitation",
      buy1Get1Free: "1 ACHETÉ, 1 OFFERT",
      buy1Get1PercentOff: "1 ACHETÉ, 1 À {0}% DE RÉDUCTION",
      buy1Get1AmountOff: "1 ACHETÉ, 1 À ${0} DE RÉDUCTION",
      validForSelectItems: "Valable pour certains articles",
      discountPercentOff: "Réduction de {0}%",
      discountAmountOff: "Réduction de {0}{1}",
      discountOff: "Réduction de {0}",
      discountUpTo: "{0}, jusqu'à {1}",
      maxDiscountReached: "Réduction maximale de {0} atteinte",
      maxDiscountOf: 'À hauteur de {0}',
      maxDiscountOfDetail: "Réduction maximale de {0}",
      offerExpires: "L'offre expire le : {0}",
      loginPrompt: "Veuillez vous connecter pour voir vos récompenses",
      inPersonRedeemable: "Cette récompense n'est utilisable qu'en magasin",
      orderRewards: {
        congrats: 'Félicitations!',
        coupons: 'Votre commande vous a valu des coupons bonus',
        lossFallback: "Désolé, vous n'avez pas gagné cette fois, veuillez réessayer lors de la prochaine commande!"
      }
    }
  },
  storePage: {
    aiRecommendationsCategory: 'Recommandé pour vous',
    aiRecommendationsCategoryGuest: 'Recommandé',
    deliveryProvider: {
      robot: 'Robot',
      human: 'Human',
      byRobot: 'Your order will be fulfilled by a robot!',
      byHuman: 'Your order will be fulfilled by a human',
      recommended: 'Recommended by this business',
      notSupported: '{0} delivery is not supported for your address', //where 0 is either Robot or Human
      deliveryInstructions: 'Please be aware, Robots cannot climb stairs. You will need to provide your emailed code in order to retrieve your food'
    },
    error: {
      empty: 'Rien à montrer ici!',
      noResults: "n'a renvoyé aucun résultat.",
      tryAdjusting: "Essayez d'ajuster votre filtre",
      clear: 'Effacer la recherche'
    }
  },
  order: {
    estimatedTime: 'Votre commande a été passée avec succès, elle sera prête pour le ramassage {0}',
    estimatedTimeDiff: 'Votre commande a été passée avec succès, elle sera prête pour le ramassage dans environ {0}',
    successfulOrder: 'Votre commande a été passée avec succès',
    deliveryAddressInvalid: "L'adresse que vous avez saisie n'est pas valide, veuillez réessayer",
    deliveryAddressMustBeSet: 'Votre adresse de livraison doit être définie',
    deliveryAddressMustBeInRange: "Désolé, votre adresse n'est pas dans la plage de livraison, veuillez contacter le magasin pour passer votre commande",
    noPaymentMethodSelected: 'Veuillez choisir un moyen de paiement',
    insufficientPoints: 'Solde des membres insuffisant',
    requiresAdditionalMethod: 'Solde insuffisant, deuxième mode de paiement requis',
    cardMinimumCharge: 'Au moins {0} doit être payé par carte. Ajoutez un pourboire ou un autre article, ou payez cette commande par carte.',
    minCardChargeNote: 'Paiement minimum par carte : {0}',
    applyMembershipInstead: 'Appliquer {0} à la place',
    noPaymentMethods: 'Veuillez choisir un moyen de paiement',
    pickUpDetails: 'Détails de ramassage',
    orderDetails: 'Détails de la commande',
    selectOrderType: 'Sélectionnez le type de commande',
    orderPlaced: 'Commande passée',
    orderScheduled: "l'heure prévue",
    orderNotes: 'Notes de commande',
    pickUpTime: 'Heure de ramassage',
    pickUpDay: 'Jour de ramassage',
    deliveryTime: 'Heure de livraison',
    deliveryDay: 'Jour de livraison',
    deliveryAddress: 'Adresse de livraison',
    addressLine1: 'Adresse 1',
    addressLine2: 'Adresse 2',
    postalCode: 'Code postal',
    city: 'Ville',
    payment: 'Paiement',
    placeOrder: 'Passer la commande',
    personalDetails: 'Détails personnels',
    tableNumberSet: 'Votre table a été dressée',
    onlyOffline: "Ce magasin n'accepte que le paiement en personne.",
    paidOffline: "La commande sera payée en personne",
    emailReceipt: "Envoyez-moi le reçu",
    offlineEmailReceipt: "Envoyez-moi la confirmation de commande",
    status: {
      new: 'Nouveau',
      inProgress: 'En cours',
      ready: 'Prêt',
      cancelled: 'Annulé',
      refunded: 'Remboursé',
      completed: 'Terminé'
    },
    orderActions: {
      call: 'Appel',
      direction: 'Les directions',
      orders: 'Afficher les commandes',
      feedbackTitle: 'Pensez à fournir des commentaires sur votre commande',
      feedbackLabel: 'Fournir une réponse'
    }
  },
  iosBanner: {
    partOne: "Cliquez sur l'icône de partage",
    partTwo: "puis sélectionnez ajouter à l'écran d'accueil",
    partThree: 'à installer'
  },
  checkoutSuccess: {
    text: 'Succès du paiement'
  },
  orderSubmitted: {
    text: 'Commande soumise'
  },
  deliveryDialog: {
    title: 'Détails de livraison',
    deliverAsap: 'Livrer ASAP',
    schedule: 'Planifier',
    update: 'Modifier',
    selectAddress: 'Veuillez saisir votre adresse',
    noDeliveryProviders: 'Aucun service de livraison ne dessert cette adresse',
    deliveryAddressSet: 'Adresse de livraison définie !',
    selectDateTime: 'Veuillez sélectionner une date et une heure valides',
    notAvailable: 'Désolé, ce n\'est pas disponible',
    pleaseSelectDate: 'Veuillez sélectionner une date'
  },
  orderDialog: {
    title: 'Détails de la collecte',
    deliveryTitle: 'Détails de la livraison',
    pickUpAsap: 'Récupérer ASAP',
    deliverAsap: 'Livrer ASAP',
    schedule: 'Planifier',
    done: 'Terminé',
    selectDate: 'Veuillez sélectionner une date',
    notAvailable: 'Désolé, ce n\'est pas disponible',
    selectDateTime: 'Veuillez sélectionner une date et une heure valides',
    noAvailableDays: "Aucun jour disponible",
    earliestDate: "La date la plus proche a été définie",
    staleTimeBodyGroup: "Le magasin ne peut pas préparer votre commande avant {0}. Choisissez un nouvel horaire pour continuer — les articles de votre groupe et de vos invités ne changeront pas.",
    staleTimeBodySolo: "Le magasin ne peut pas préparer votre commande avant {0}. Choisissez un nouvel horaire pour continuer.",
    confirmSlot: "Confirmer {0}",
    goBack: "Retour"
  },
  storeLocation: {
    pickUpAt: 'Récupérer',
    inStore: 'En magasin',
    pickUpTime: 'Heure de récupération',
    deliveryTime: 'Heure de livraison',
    time: 'Heure',
    deliverTo: 'Livrer à',
    clickToSet: 'Cliquer pour définir'
  },
  orderTypes: {
    pickup: 'À emporter',
    delivery: 'Livraison',
    dineIn: 'Sur place'
  },
  groupOrder: {
    title: 'Commande de groupe',
    namePlaceholder: 'Nom de la commande de groupe',
    from: 'De',
    deliverTo: 'Livrer à',
    pickupAt: 'Récupérer à',
    invitePeople: 'Inviter des personnes',
    chooseWhoPays: 'Choisir qui paie',
    paySubtitle: "L'hôte (vous) sera facturé pour l'ensemble de la commande de groupe. Le mode de paiement sera saisi lors du paiement.",
    youPayForEveryone: 'Vous payez pour tout le monde',
    hostWillPayForEveryone: 'L\'hôte paiera pour tout le monde',
    limitPlaceholder: 'Entrer une limite par personne (optionnel)',
    perPerson: 'par personne',
    everyonePaysThemselves: 'Chacun paie pour soi',
    comingSoon: 'Bientôt disponible',
    next: 'Suivant',
    yourGroupOrderLink: 'Votre lien de commande de groupe',
    copy: 'Copier',
    share: 'Partager',
    linkCopied: 'Lien copié !',
    join: 'Rejoindre la commande de groupe de {0}',
    spendingLimit: 'Limite de dépenses',
    limitNoLimit: 'Sans limite',
    limitOther: 'Autre',
    joinGroupOrder: 'Rejoindre la commande de groupe',
    joining: 'Connexion en cours...',
    loginToJoin: 'Se connecter pour rejoindre',
    continueAsGuest: "Continuer en tant qu'invité",
    enterYourName: 'Entrez votre nom',
    joinOrderDisclaimer: "En cliquant sur REJOINDRE, vous acceptez",
    joinOrder: 'REJOINDRE',
    back: 'Retour',
    notSet: 'Non défini',
    cancelGroupOrder: 'Annuler la commande de groupe',
    cancelGroupOrderConfirmTitle: 'Annuler {0} ?',
    cancelGroupOrderConfirmBody: 'Cela mettra fin à la commande de groupe pour tout le monde. Tous les participants seront retirés.',
    cancelGroupOrderConfirm: 'Oui, annuler',
    cancelGroupOrderKeep: 'Conserver la commande de groupe',
    cartMenuCancelGroup: 'Annuler la commande de groupe',
    cartMenuLeaveGroup: 'Quitter',
    cartMenuInvite: 'Inviter des personnes',
    lockedBannerGuest: 'Cette commande de groupe a été verrouillée. Veuillez contacter l\'hôte pour effectuer des modifications.',
    lockedBannerHost: 'Votre panier est verrouillé. Vous pouvez toujours procéder au paiement.',
    unlockMyCart: 'Déverrouiller mon panier',
    othersInGroup: 'Autres membres de votre groupe ({0} personnes)',
    othersHaveAdded: '{0} sur {1} ont ajouté des articles',
    memberHostLabel: '(Hôte)',
    memberReadyBadge: 'Prêt',
    memberWaitingBadge: 'En attente',
    memberErrorBadge: 'Article indisponible',
    memberCartHasErrors: 'Une personne de votre groupe a un article indisponible. Retirez-le pour continuer.',
    memberNoItems: 'Aucun article pour l\'instant',
    unlockMemberCart: 'Déverrouiller le panier de {0}',
    removeMember: 'Retirer {0}',
    yourItems: 'Vos articles',
    leaveConfirmTitle: 'Quitter cette commande de groupe ?',
    leaveConfirmBody: 'Vos articles seront supprimés et l\'hôte sera notifié de votre départ.',
    leaveConfirmBtn: 'Quitter',
    leaveConfirmKeep: 'Annuler',
    removeConfirmTitle: 'Retirer {0} de cette commande de groupe ?',
    removeConfirmBody: "Les articles de {0} seront supprimés et ils seront informés de leur retrait.",
    removeConfirmBtn: 'Retirer {0}',
    checkoutConfirmTitle: 'Tout le monde est-il prêt ?',
    checkoutConfirmBody: 'Si vous continuez, la commande de groupe sera verrouillée et personne ne pourra apporter de modifications.',
    unreadyConfirmTitleSingle: '{0} commande encore',
    unreadyConfirmTitleMulti: '{0} invités commandent encore',
    unreadyConfirmBody: 'Le paiement ferme la commande pour tout le monde.',
    unreadyConfirmWaitingOnPrefix: 'En attente de ',
    unreadyConfirmWaitingOnSuffix: '.',
    and: 'et',
    andOthers: 'et {0} autres',
    checkoutWithCurrentBtn: 'Payer avec leurs paniers',
    checkoutWithCurrentSubtext: "La commande inclut ce qu'ils ont ajouté jusqu'à présent",
    removeCartsCheckoutBtn: 'Payer sans eux',
    removeCartsCheckoutSubtext: 'Leurs paniers et articles sont retirés de la commande',
    errorRemoveUnreadyCarts: "Impossible de retirer certains paniers. Veuillez réessayer.",
    groupCartEmpty: 'Ajoutez au moins un article avant de payer.',
    participantWaiting: 'En attente...',
    notReadyCount: '{0} participant(s) pas encore prêt(s)',
    goToCheckout: 'Passer à la caisse',
    lockedInGroupOrder: "Vous êtes dans une commande de groupe — le type de commande et l'heure ne peuvent pas être modifiés.",
    checkoutProcessing: 'Traitement en cours...',
    checkoutBackBtn: 'Retour',
    readyBtn: 'Vous êtes prêt !',
    readyHint: "L'hôte passera la commande pour tout le monde.",
    readyStatus: 'Vous êtes prêt !',
    imReadyBtn: 'Je suis prêt !',
    addItemsBtn: 'Ajouter des articles',
    lockedCheckoutBtn: 'Commande de groupe verrouillée',
    lockedTimeoutBtn: 'Commande verrouillée — temps écoulé',
    exceedsLimit: 'Dépasse la limite de la commande de groupe',
    snackParticipantLeft: '{0} a quitté la commande de groupe.',
    errorMarkReady: 'Échec de la mise à jour du statut. Veuillez réessayer.',
    errorCartLocked: "L'hôte a verrouillé la commande. Vous ne pouvez pas apporter de modifications maintenant.",
    errorUnlockCart: 'Impossible de déverrouiller le panier. Veuillez réessayer.',
    errorLockGroup: 'Échec du verrouillage de la commande de groupe. Veuillez réessayer.',
    errorLeaveGroup: 'Échec de la sortie de la commande de groupe. Veuillez réessayer.',
    errorCancelGroup: "Échec de l'annulation de la commande de groupe. Veuillez réessayer.",
    errorUnlockMember: 'Échec du déverrouillage du panier. Veuillez réessayer.',
    errorRemoveParticipant: 'Échec de la suppression du participant. Veuillez réessayer.',
    dialogRemovedTitle: 'Vous avez été retiré',
    dialogRemovedBody: "L'hôte vous a retiré de cette commande de groupe. Vos articles ont été effacés.",
    dialogLeftTitle: 'Vous avez quitté {0}',
    dialogLeftBody: 'Vos articles ont été effacés.',
    dialogCancelledTitle: 'Commande de groupe annulée',
    dialogCancelledBody: "L'hôte a annulé cette commande de groupe.",
    dialogPaidTitle: 'Commande passée !',
    dialogPaidBody: 'Votre commande de groupe a été passée avec succès.',
    dialogRecoveredTitle: 'Vous avez une commande de groupe en cours',
    dialogRecoveredHost: 'Vous êtes l\'hôte',
    dialogRecoveredGuest: 'Vous êtes un participant',
    dialogRecoveredBtn: 'Continuer',
    deadlineTitle: 'Fixer une date limite',
    deadlineSubtitle: 'Quand tout le monde doit-il commander ?',
    deadlineDayLabel: 'Commander avant (Jour)',
    deadlineTimeLabel: 'Commander avant (Heure)',
    noDeadline: 'Sans date limite',
    noDeadlineSet: 'Aucune date limite',
    deadlineSpecificTime: 'Heure spécifique',
    orderDeadline: 'Date limite de commande',
    orderBeforeDeadline: 'Commander avant {0}',
    peopleCanOrderAnytime: 'Les gens peuvent commander à tout moment',
    notAvailableScheduled: 'Non disponible pour cette heure programmée',
    deadlineNotAvailableNow: "La date limite n'est pas disponible quand la livraison est réglée sur Maintenant.",
    noAvailableDeadlineTimes: 'Aucun horaire disponible pour une date limite. Veuillez sélectionner une heure de livraison ultérieure.',
    noSpendingLimit: 'Aucune limite de dépense',
    spendingLimitValue: 'Limite de {0}',
    dialogChangedTitle: 'Commande mise à jour par l\'hôte',
    dialogChangedToDelivery: 'Changé en Livraison',
    dialogChangedToPickup: 'Changé en Retrait',
    dialogChangedTime: 'Heure modifiée de {0} à {1}',
    dialogChangedTimeSet: 'Heure programmée définie à {0}',
    dialogChangedTimeCleared: 'Heure programmée supprimée (dès que possible)',
    timeChangedLabel: 'Heure modifiée',
    timeChangedToLabel: 'Heure modifiée à',
    confirmChangeToDelivery: 'Changer en Livraison ?',
    confirmChangeToPickup: 'Changer en Retrait ?',
    confirmChangeTypeBody: 'Cela mettra à jour le type de commande pour tous les membres du groupe.',
    asap: 'Dès que possible',
    orderAsap: 'Commander dès que possible',
    now: 'Maintenant',
    staleTimeTitle: "L'heure sélectionnée n'est plus disponible",
    staleTimeNearestSlotLabel: "Heure disponible la plus proche",
    staleTimeChooseAnother: 'Choisir une autre heure',
    errorResetSchedule: "Échec de la mise à jour. Veuillez réessayer.",
    errorUpdateSchedule: "Échec de la mise à jour. Veuillez réessayer.",
    errorUpdateScheduleConflict: "Impossible de mettre à jour pour le moment. Veuillez vérifier et réessayer.",
    discountsAtCheckout: 'Réductions appliquées au paiement',
    deliveryFeeAtCheckout: 'Calculé au paiement',
    feesCalculatedAtCheckout: 'Taxes, frais et réductions calculés au paiement',
    exceedsSpendingLimit: "Cet article dépasserait la limite de dépenses fixée par l'hôte.",
    cartFinalized: 'Votre commande de groupe a été finalisée. Vous ne pouvez plus ajouter d\'articles.',
    noDeadlineSlots: 'Aucun créneau disponible pour fixer une limite de temps.',
    errorUpdateDeadline: 'Impossible de mettre à jour la limite. Veuillez réessayer.',
    deadlineUpdated: 'Limite de commande mise à jour : {0}',
    deadlineRemoved: 'Limite de commande mise à jour.',
    shareGroupOrder: 'Rejoignez ma commande de groupe !',
    memberLocked: 'Verrouillé',
    snackParticipantLeftHost: '{0} a quitté la commande de groupe.',
    tooltipBadgeNew: 'NOUVEAU',
    tooltipTitle: 'Comment fonctionne la Commande de Groupe',
    tooltipScene1Caption: 'Démarrez une commande de groupe depuis la page du menu',
    tooltipScene2Caption: 'Définissez une date limite — et qui paie',
    tooltipScene3Caption: 'Partagez le lien, ou laissez vos amis scanner pour rejoindre',
    tooltipScene4Caption: 'Tout le monde ajoute à un seul panier. Un seul paiement.',
    tooltipStartBtn: 'Démarrer une Commande de Groupe',
    tooltipGotItBtn: 'Compris',
    tooltipDemoPeopleJoined: '{0} personnes ont rejoint',
    tooltipDemoDeadlineTimeExample: 'Ven, 10 juil · 12h30',
    tooltipDemoPaySub: 'Vous payez · limite de 15$ chacun',
    tooltipDemoLinkExample: 'gosnappy.io/g/tonnys-order…',
    tooltipDemoGroupCartLabel: 'Panier de groupe',
    tooltipDemoOneCheckout: 'Un seul paiement — vous payez',
    sheetTitle: 'La commande de groupe est arrivée',
    sheetSubtitle: 'Commandez ensemble — un panier partagé, un seul paiement.',
    sheetBullet1: 'Définissez une date limite de commande',
    sheetBullet2: 'Vous payez — ou fixez une limite de dépense',
    sheetBullet3: 'Invitez avec un lien ou un code QR',
    sheetNotNowBtn: 'Pas maintenant',
    showHowItWorks: 'Montrez-moi comment ça marche',
    hostSetsTip: 'En tant qu\'hôte, vous définissez le pourboire pour toute la commande de groupe.',
    checkoutErrorGeneric: 'Le paiement a échoué. Veuillez réessayer.',
    checkoutErrorInvalidCart: 'Certains articles du panier nécessitent votre attention avant de continuer.',
    checkoutErrorOutOfStock: 'Certains articles ne sont plus disponibles. Veuillez les retirer et réessayer.',
    checkoutErrorMissingSelection: 'Veuillez vérifier les sélections d\'un article du panier.',
    checkoutErrorInvalidItem: 'Un article du panier n\'est plus valide. Veuillez le retirer et réessayer.',
    checkoutErrorPaymentDeclined: 'Votre carte a été refusée. Veuillez essayer un autre moyen de paiement.',
    checkoutErrorPaymentFraud: 'Ce moyen de paiement a été refusé par l\'émetteur de la carte. Veuillez en essayer un autre.',
    checkoutErrorCardDetails: 'Il y a un problème avec les informations de la carte. Veuillez les vérifier et réessayer.',
    checkoutErrorCardExpired: 'Cette carte a expiré. Veuillez essayer un autre moyen de paiement.',
    checkoutErrorPaymentGateway: 'Le paiement n\'a pas pu être traité. Veuillez réessayer.',
    checkoutErrorNotOpen: 'Cette commande de groupe n\'est plus ouverte.',
    checkoutErrorVersionConflict: 'La commande de groupe a changé pendant votre paiement. Veuillez vérifier et réessayer.',
    checkoutErrorInProgress: 'Le paiement est déjà en cours.',
    checkoutErrorEmpty: 'Le panier du groupe est vide.',
    checkoutErrorBlocked: 'Certains participants ne sont pas encore prêts.',
  },
  weChat: {
    warning: 'Veuillez quitter la page et utiliser WeChat Scanner pour scanner le code QR',
    title: 'Entrez le numéro de la table'
  },
  checkout: {
    addCoupon: 'Ajouter un coupon',
    couponCode: 'Code de coupon',
    title: 'Soumettre la commande',
    description: 'Êtes-vous prêt à soumettre votre commande?',
    confirmCancel: 'Non',
    confirmApprove: 'Oui',
    onlinePay: 'Paiement en ligne',
    weChatPay: 'WeChat Pay',
    unitNumber: "Numéro d'unité (facultatif)",
    primaryMethod: 'Paiement',
    secondaryMethod: 'Deuxième mode de paiement',
    credits: 'Portefeuille de magasin',
    orderHints: 'c.-à-d. toute restriction alimentaire',
    deliveryHints: 'c.-à-d. sonner la cloche après la livraison, laisser à côté du porche, numéro de sonnerie, etc',
    deliveryOptions: 'Options de livraison',
    deliveryInstructions: 'Instructions de livraison',
    orderDisposables: 'Ustensiles, pailles, etc.',
    deliveryDisposables: 'Ustensiles jetables',
    disposablesIncluded: "Ces articles ne seront pas inclus sauf si vous demandez",
    noPaymentMethods: "Aucune option de paiement n'est disponible.<br>Veuillez contacter {0}",
    billLoadError: 'Nous n\'avons pas pu charger le total de votre commande. Veuillez réessayer.',
    applePayFailed: 'Apple Pay n\'a pas pu démarrer. Veuillez réessayer ou choisir un autre moyen de paiement.',
    retry: 'Réessayer',
    confirmDialog: {
      total: 'Total',
      name: 'Nom du magasin',
      location: 'Emplacement du magasin',
      deliveryInfo: 'Informations de livraison',
      deliveryAddress: 'Adresse de livraison',
      deliveryPhone: 'Numéro de téléphone de livraison',
      scheduled: 'Prévu pour',
      pay: 'Pay',
      pickupTitle: 'Ramasser au magasin?',
      pickupBody: 'Confirmez que vous viendrez récupérer cette commande au magasin.',
      pickupTime: 'Heure de ramassage:',
      beforeYouArrive: 'Avant votre arrivée',
      yesPickUp: 'Oui, je ramasse',
      goBack: 'Retour'
    },
    deliveryMessage: {
      leave_at_door: 'Laisser à la porte',
      meet_at_door: 'Rencontre à la porte',
      meet_outside: "Rencontrer à l'extérieur"
    },
    couponTypes: {
      title: 'Votre coupon limite vos options de paiement à:',
      membership: 'Portefeuille de magasin',
      online: 'Cartes de crédit',
      wechat: 'WeChat',
      offline: 'Payer en personne'
    }
  },
  qr: {
    manulInput: 'Le scanner ne fonctionne pas? Veuillez entrer votre numéro de table.',
    selectTable: 'Votre numéro de table',
    select: 'Confirmer'
  },
  apps: {
    giftcard: 'Cartes Cadeaux',
    coupons: 'Coupons',
    deposit: 'Ajouter des Fonds',
    lineup: "Liste d'Attente",
    reservation: 'Réservations'
  },
  requestService: {
    openButton: 'Demande de service',
    title: 'Faites une demande de votre serveur',
    sent: 'Demande envoyée',
    login: 'Doit être connecté pour utiliser cette fonctionnalité',
    tableNeeded: 'Veuillez définir votre numéro de table pour utiliser cette fonctionnalité'
  },
  sharedCart: {
    bannerLabel: 'Table partagée · Table #{0}',
    live: 'En direct',
    staleItemWarning: 'Mis à jour par un autre client — vérifiez avant de sauvegarder',
    sentToKitchen: 'Envoyé en cuisine',
    roundSentToKitchen: 'Tour {0} · Envoyé en cuisine',
    alreadyOrdered: 'Déjà commandé',
    itemCount: '{0} articles',
    stillOrdering: 'Ajout en cours',
    sending: 'Envoi...',
    reconnected: 'Reconnecté à la table partagée {0}.',
    joinedTitle: 'Vous avez rejoint la table!',
    joinedBody: 'Vous partagez maintenant la commande de cette table avec tout le monde ici.',
    completedTitle: 'Commande de table payée!',
    completedBody: 'Le paiement de cette table a été effectué. Merci!',
    billAtPosTitle: 'Facture envoyée à la caisse',
    billAtPosBody: 'La facture de votre table a été envoyée à la caisse. Veuillez payer là-bas pour terminer votre commande.',
    cancelledTitle: 'Session de table terminée',
    cancelledBody: 'La session de panier partagé de cette table a expiré. Veuillez scanner le QR code pour démarrer une nouvelle session.',
    roundFired: 'Articles envoyés en cuisine.',
    errorFireRound: 'Échec de l\'envoi en cuisine. Veuillez réessayer.',
    errorItemChanged: 'Quelqu\'un d\'autre a déjà modifié cet article — actualisé avec la dernière version, veuillez réessayer.',
    errorMutateCart: 'Cela n\'a pas fonctionné. Veuillez réessayer.',
    errorSessionClosed: 'Cette table a déjà été fermée.',
    sharedTable: 'Table Partagée',
    sharedTableActive: '● Table Partagée Active',
    tableLabel: 'Table {0}',
    errorStartSharedTable: 'Impossible de démarrer la table partagée. Veuillez réessayer.',
  },
}
